import * as types from './mutation-types'
export const getAccountLink = ({commit}) => {
  return Vue2.prototype.$api.active().get('payments/account/link')
    .then(({ data }) => {
      return data.url
    })
    .catch((error) => {
      commit('baseAddNotification', {
        type: 'error',
        title: 'Error',
        text: error.message,
      })
      throw error
    })
}

export const paymentsCreateBankAccount = async ({commit}, data) => {
  return await Vue2.prototype.$api.active().post('payments/account/bank-account', data)
}

export const paymentsUpdateBankAccount = async ({commit}, data) => {
  return await Vue2.prototype.$api.active().patch('payments/account/bank-account', data)
}

export const paymentsRefreshAccount = async ({commit}) => {
  const { data } = await Vue2.prototype.$api.active().get('payments/account/refresh')

  commit(types.PAYMENTS_SET_STRIPE_ACCOUNT, data.stripeAccount)
}

export const paymentsAttachPaymentMethod = ({commit}, data) => {
  return Vue2.prototype.$api.active().post(`payments/methods`, data).then((response) => {
    commit(types.PAYMENTS_ADD_PAYMENT_METHOD, response.data)
    return response
  })
}

export const paymentsGetPaymentMethods = ({commit}) => {
  return Vue2.prototype.$api.active().get(`payments/methods`).then((response) => {
    commit(types.PAYMENTS_SET_PAYMENT_METHODS, response.data)
    return response
  })
}

export const paymentsGetMembershipFee = ({ commit }, data) => {
  return Vue2.prototype.$api.active().get(`payments/membership-fee`).then((response) => {
    commit(types.PAYMENTS_SET_MEMBERSHIP_FEE, response.data)
    return response
  }).catch((error)=>{
    commit('baseAddNotification', {
      type: 'error',
      title: 'Error',
      text: error.message,
    })
    throw error
  })
}

export const paymentsUpdateMembershipFee = ({ commit }, data) => {
  return Vue2.prototype.$api.active().put(`payments/membership-fee`, data).then((response) => {
    commit(types.PAYMENTS_SET_MEMBERSHIP_FEE, response.data)
    return response
  })
}

export const paymentsCreateSetupIntent = ({ commit }, data) => {
  return Vue2.prototype.$api.active().post(`payments/prepare`, data).then((response) => {
    commit(types.PAYMENTS_SET_SETUP_INTENT, response.data)
    return response
  }).catch((error)=>{
    commit('baseAddNotification', {
      type: 'error',
      title: 'Error',
      text: error.message,
    })
    throw error
  })
}

export const paymentsSubmitMembershipFee = ({ commit }, data) => {
  return Vue2.prototype.$api.active().post('payments/membership-fee/submit', data).then((response) => {
    commit('baseAddNotification', {
      type: 'success',
      title: 'Success',
      text: 'Payment Succeeded',
    })
    return response
  }).catch((error)=>{
    commit('baseAddNotification', {
      type: 'error',
      title: 'Error',
      text: error.message,
    })
    throw error
  })
}

export const paymentsGetPayments = ({ commit }, data) => {
  let uri = `payments?`

  if(data.page) {uri = uri +  `page=${data.page}`}
  if(data.membership) {uri = uri + `&membership=${data.membership}`}
  if(data.include) {uri = uri +  `&include=${data.include}`}
  if(data.search) {uri = uri +  `&search=${data.search}`}
  if(data.filter) {uri = uri +  `&filter=${data.filter}`}

  return Vue2.prototype.$api.active().get(uri).then((response) => {
    commit(types.PAYMENTS_SET_PAYMENTS, response.data)
    return response
  }).catch((error)=>{
    commit('baseAddNotification', {
      type: 'error',
      title: 'Error',
      text: error.message,
    })
    throw error
  })
}

export const paymentsGetLatestPayment = ({ commit }, data) => {
  return Vue2.prototype.$api.active().get(`payments?membership=${data.membershipUuid}&page=1&per_page=1`).then((response) => {
    commit(types.PAYMENTS_SET_LATEST_PAYMENT, response.data.data[0])
    return response
  }).catch((error)=>{
    commit('baseAddNotification', {
      type: 'error',
      title: 'Error',
      text: error.message,
    })
    throw error
  })
}

export const paymentsGetRevenueProjection = ({ commit }, data) => {
  return Vue2.prototype.$api.active().get(`payments/revenue/project?interval_start=${data.interval_start}&interval_end=${data.interval_end}&breakdown_unit=${data.breakdown_unit}`).then((response) => {
    commit(types.PAYMENTS_SET_REVENUE_PROJECTION, response.data)
    return response
  }).catch((error)=>{
    commit('baseAddNotification', {
      type: 'error',
      title: 'Error',
      text: error.message,
    })
    throw error
  })
}

export const paymentsCreateRefund = ({ commit }, data) => {
  return Vue2.prototype.$api.active().post(`payments/${data.paymentUuid}/refunds`, data.params).then((response) => {
    commit('baseAddNotification', {
      type: 'success',
      title: 'Success',
      text: 'Payment has been refunded.',
    })
    return response
  })
}

export const paymentsGetRefunds = ({ commit }, data) => {
  let uri = `payments/refunds?`

  if(data.page) {uri = uri +  `page=${data.page}`}
  if(data.include) {uri = uri +  `&include=${data.include}`}
  if(data.search) {uri = uri +  `&search=${data.search}`}
  if(data.filter) {uri = uri +  `&filter=${data.filter}`}

  return Vue2.prototype.$api.active().get(uri).then((response) => {
    commit(types.PAYMENTS_SET_REFUNDS, response.data)
    return response
  }).catch((error)=>{
    commit('baseAddNotification', {
      type: 'error',
      title: 'Error',
      text: error.message,
    })
    throw error
  })
}

export const getPaymentInvoicePdfLink = ({commit}, paymentUuid) => {
  return Vue2.prototype.$api.active().get(`payments/${paymentUuid}/invoice-pdf-link`)
    .then(({ data }) => {
      console.log(data)
      return data
    })
    .catch((error) => {
      commit('baseAddNotification', {
        type: 'error',
        title: 'Error',
        text: error.message,
      })
      throw error
    })
}